module.exports = __webpack_public_path__ + "assets/e73e037d47b04038c4425d3479deccdd.png";